import { Co2LockIcon } from '@/common/components/icons'
import { StoredCO2AmountTonnes } from '@/api/EmissionReportModel'
import ReportSectionCard from '../ReportSectionCard'
import { UnitLabel } from '@/shared/config/config'
import { useTranslation } from 'react-i18next'
import { GenericDialog } from '@/common'
import StoredCO2Reporting from './StoredCO2Reporting'
import { StoredCO2Handling } from '@/features/production-routes/api/ProductionRouteModel'
import useDialog from '@/common/hooks/useDialog'

export default function StoredCo2Section({
  isComplete,
  storedCO2AmountTonnes,
  isViewMode,
  reportId,
  storedCO2Handling,
  processId
}: {
  isComplete: boolean
  storedCO2AmountTonnes?: StoredCO2AmountTonnes
  isViewMode: boolean
  reportId: string
  storedCO2Handling: StoredCO2Handling
  processId: string
}) {
  const { t } = useTranslation()
  const { open, openDialog, closeDialog } = useDialog()
  const completionPercentage = isComplete ? 100 : 0
  return (
    <>
      <ReportSectionCard
        icon={<Co2LockIcon className="size-4" />}
        title={t('report:storedCO2.title')}
        reportButtonText={t('report:storedCO2.reportButtonText')}
        onEdit={openDialog}
        isComplete={isComplete}
        isViewMode={isViewMode}
        completionPercentage={completionPercentage}
      >
        <p className="font-semibold text-text-main">
          {storedCO2AmountTonnes || 0} {UnitLabel.tCO2}
        </p>
      </ReportSectionCard>
      <GenericDialog
        title={t('report:storedCO2.title')}
        isOpen={open}
        close={closeDialog}
        size="xl"
      >
        <StoredCO2Reporting
          close={closeDialog}
          initialValue={{ storedCO2AmountTonnes: storedCO2AmountTonnes }}
          storedCO2Handling={storedCO2Handling}
          reportId={reportId}
          processId={processId}
        />
      </GenericDialog>
    </>
  )
}
